<!-- eslint-disable no-console -->
<script>
export default {
  props: {
    percent: {
      type: Number,
      default: 100
    }
  },
  data: () => ({
    path: '', // m 10 163 A150 150 0 0 1 13.27 131.81
    pointTrans: 'rotate(90, 156.5, 147.8)',
    innerPath: 'M 290 163 A130 130 0 0 0 290 163', // "m 30 163 A130 130 0 0 1 163 33"
  }),
  methods: {
    getPath() {
      const arr = [1, 3, 5, 8]
      const temp = []
      const degArr = [[10, 163]]
      const deg = 4
      const r = 150
      const x = 10
      const y = 163
      arr.forEach(item => {
        temp.push(item * 18 - deg)
        temp.push(item * 18 + deg)
      })
      temp.forEach(degree => degArr.push(this.computePos(degree, r, x, y)))
      degArr.push([310, 163])
      let path = ''
      for (let i = 0; i < degArr.length; i++) {
        path += `M ${degArr[i][0]} ${degArr[i][1]} A150 150 0 0 1 ${degArr[i + 1][0]} ${degArr[i + 1][1]} `
        i += 1
      }
      this.path = path
    },
    computePos(degree, r, x, y) {
      const s = Math.sin(degree * Math.PI / 180) * r
      const c = Math.cos(degree * Math.PI / 180) * r
      const x1 = x + r - c
      const y1 = y - s
      return [x1, y1]
    },
    animateToNewPercent(oldPercent, newPercent) {
      // percent 转度数
      let oldDeg = oldPercent * 1.8 - 90
      let newDeg = newPercent * 1.8 - 90
      let deg = oldDeg
      // 归零
      let inter = setInterval(() => {
        if (deg >= 90) {
          clearInterval(inter)
          // 转到新的位置
          inter = setInterval(() => {
            // rotate(45, 159.2, 145.8)
            if (deg <= newDeg) {
              clearInterval(inter)
            }
            const pos = this.computePos(deg + 90, 130, 30, 163)
            this.pointTrans = `rotate(${deg}, 156.5, 147.8)`
            this.innerPath = `M 290 163 A130 130 0 0 0 ${pos[0]} ${pos[1]} `
            deg--
          }, 10)
        }
        const pos = this.computePos(deg + 90, 130, 30, 163)
        this.pointTrans = `rotate(${deg}, 156.5, 147.8)`
        this.innerPath = `M 290 163 A130 130 0 0 0 ${pos[0]} ${pos[1]} `
        deg++
      }, 0)
    }
  },
  mounted() {
    this.getPath()
    this.animateToNewPercent(100, this.percent)
  },
  watch: {
    percent: {
      handle: function(newVal, oldVal) {
        this.animateToNewPercent(oldVal, newVal)
      },
      // immediate: true
    }
  }
}
</script>
<template>
  <div class="dashboard">
    <svg width="100%" height="100%" viewBox="0 0 330 170" >
        <defs>
          <linearGradient id="bg1">
            <stop offset="0%" stop-color="#acd2f7" stop-opacity="0.1" />
            <stop offset="20%" stop-color="#acd2f7" stop-opacity="0.8" />
            <stop offset="50%" stop-color="#acd2f7" />
            <stop offset="80%" stop-color="#acd2f7" stop-opacity="0.8" />
            <stop offset="100%" stop-color="#acd2f7" stop-opacity="0.1" />
          </linearGradient>
          <linearGradient id="bg2">
            <stop offset="0%" stop-color="#4fe4b7" />
            <stop offset="75%" stop-color="#46bdff" />
            <stop offset="100%" stop-color="#46a0ff" />
          </linearGradient>
          <linearGradient id="bg3">
            <stop offset="0%" stop-color="#acd2f7" stop-opacity="0.1" />
            <stop offset="2%" stop-color="#acd2f7" stop-opacity="0.8" />
            <stop offset="50%" stop-color="#acd2f7" />
            <stop offset="94%" stop-color="#acd2f7" stop-opacity="0.8" />
            <stop offset="100%" stop-color="#acd2f7" stop-opacity="0.1" />
          </linearGradient>
          <filter id="f1">
            <feOffset result="offOut" in="SourceGraphic" dx="0" dy="3" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="5" />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
          </filter>
          <filter id="filter0_d_2276_10853" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="3.2"/>
            <feGaussianBlur stdDeviation="5"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.7 0 0 0 0 0.86 0 0 0 0 1 0 0 0 1 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2276_10853"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2276_10853" result="shape"/>
          </filter>
          <filter id="filter1_d_2276_10853" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="3.42062"/>
            <feGaussianBlur stdDeviation="5.13093"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.696076 0 0 0 0 0.862936 0 0 0 0 1 0 0 0 1 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2276_10853"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2276_10853" result="shape"/>
          </filter>
        </defs>
        <path
            fill="none"
            stroke-linecap="round"
            class="outer-arc"
            stroke="url(#bg3)"
            filter="url(#filter1_d_2276_10853)"
            stroke-width="1.8" :d="path" />
      
        <text x="5" y="160" fill="#9fbedc" class="font" >0</text>
        <text x="12" y="120" fill="#9fbedc" class="font" >10</text>
        <text x="65" y="48" fill="#9fbedc" class="font" >30</text>
        <text x="152" y="18" fill="#9fbedc" class="font" >50</text>
        <text x="275" y="80" fill="#9fbedc" class="font" >80</text>
        <text x="304" y="160" fill="#9fbedc" class="font" >100</text>
        <path
            fill="none"
            stroke-linecap="square"
            class="outer-arc"
            stroke="url(#bg1)"
            filter="url(#filter0_d_2276_10853)"
            stroke-width="10" d="m 30 163 A130 130 0 0 1 290 163" />
        <path
          fill="none"
          stroke-linecap="round"
          class="inner-arc"
          stroke="url(#bg2)"
          stroke-width="10" :d="innerPath" />

        <path d="M10 170H310" stroke="#B5D7F7" stroke-width="1.7"/>
        <path class="point-trans" :transform="pointTrans" fill-rule="evenodd" clip-rule="evenodd" d="M156.459 49.1892C154.343 49.1892 152.602 50.8551 152.508 52.9693L148.322 147.576C148.117 152.211 151.82 156.081 156.459 156.081C161.099 156.081 164.802 152.211 164.596 147.576L160.41 52.9693C160.317 50.8551 158.576 49.1892 156.459 49.1892ZM156.459 152.297C159.071 152.297 161.189 150.18 161.189 147.568C161.189 144.955 159.071 142.838 156.459 142.838C153.847 142.838 151.73 144.955 151.73 147.568C151.73 150.18 153.847 152.297 156.459 152.297Z" fill="#6555FF"/>
        <!-- <circle cx="156.5" cy="147.8" r="3" fill="white"></circle> -->
      </svg>
  </div>
</template>
<style lang="less" scoped>
.dashboard {
  --width: 300px;
  --height: 150px;
  width: var(--width);
  height: var(--height);
  margin: 0 auto;
  // background: #000;
  .font {
    font-size: 13px;
  }
  .point-trans {
    
  }
}
</style>